module.exports = __webpack_public_path__ + "static/media/rainwater.3b6e6017.svg";